<template>
  <div class="projects">
    <!-- <vue-masonry-wall class="project-wrapper" :items="projectData" :options="{ width: 400, padding: 12 }">
      <template v-slot:default="{ item }">
        <div :key="item.project_id" class="project-item" @click="toDetail(item.project_id)">
          <img v-lazy="getTokenUrl(item.all_tokens)">
          <div class="overlay">
            <div class="block-wrapper">
              <span class="title">{{ item.project_name }}</span>
              <span class="author">{{ item.project_artist }}</span>
            </div>
          </div>
        </div>
      </template>
    </vue-masonry-wall> -->
    <my-brand :routerlist="routerlist" />
    <div
      v-for="item in projectData"
      :key="item.project_id"
      class="project-wrapper"
    >
      <pannel
        :data="item"
        :random-token="getToken(item.all_tokens)"
        data-aos="zoom-in"
        data-aos-offset="100"
        data-aos-easing="ease-in-sine"
        data-aos-duration="600"
      >
        <p slot="projectItem" class="single-item">
          <span class="title">Price per token</span>
          <span class="value">{{
            getTokenPrice(item.token_info && item.token_info.PricePerTokenInWei)
          }}</span>
        </p>
        <!-- <p slot="projectItem" class="single-item">
          Website
          <a :href="item.project_website" class="value site">{{ item.project_website }}</a>
        </p>
        <p slot="projectItem" class="single-item">
          License
          <span class="value">{{ item.project_license }}</span>
        </p> -->
        <p slot="projectItem" class="single-item">
          <span class="title">Total Minted</span>
          <span class="value">
            {{ item.all_tokens && item.all_tokens.length }} /
            {{ item.token_info && item.token_info.MaxInvocations }} MAX
          </span>
        </p>

        <button
          slot="btnContent"
          class="hvr-shutter-out-vertical w100p"
          @click="toDetail(item.project_id)"
        >
          Visit Project
        </button>
      </pannel>
    </div>

    <div v-if="isShowPage || projectData.length == 0" class="page">
      <Page
        size="small"
        :total="count"
        show-elevator
        :page-size="showNum"
        :current="pageNum"
        @on-change="handlePage"
      />
    </div>
  </div>
</template>

<script>
import * as http from "@/common/utils/request.js";
import Web3 from "web3";
import { getRandomToken } from "@/common/utils/utils";
export default {
  data() {
    return {
      projectData: [],
      isShowPage: false,
      pageNum: 1,
      showNum: 100,
      count: 0,
    };
  },
  components: {
    pannel: () => import("@/components/basic/detailPanel.vue"),
  },
  methods: {
    toDetail(id) {
      this.$router.push(`/projectDetail/${id}`);
    },

    getTokenPrice(price) {
      if (!price) {
        return false;
      }
      const res = Web3.utils.fromWei(price);
      return `${res} ETH`;
    },
    //切换分页
    handlePage(val) {
      this.pageNum = val;
      this.getProjectList();
    },
    // 项目列表
    async getProjectList() {
      const params = {
        pageNum: this.pageNum,
        showNum: this.showNum,
        active: true,
      };
      try {
        const res = await http.fetchGet("/api/listProjects", params);
        console.log({ res });
        this.projectData = res.data?.data?.projects;
        this.count = res.data?.data?.count;
        if (this.count > 100) {
          this.isShowPage = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 获取随机token
    getToken(tokens) {
      if (!tokens || tokens.length <= 0) {
        return "";
      }
      const randomToken = getRandomToken(tokens);
      return randomToken;
    },

    // // 随机token链接
    // getTokenUrl(tokens) {
    //   // 没有token
    //   if (tokens.length === 0) {
    //     return `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNuvafpok1f34VfmtLMX_0RYNYnJ-aSpv0qQ&usqp=CAU`;
    //   }

    //   const randomToken = tokens[Math.floor(Math.random() * tokens.length)];
    //   // console.log(randomToken);
    //   return `http://59.110.68.178:8004/art/${randomToken}/png`;
    // },
  },
  mounted() {
    this.getProjectList();
  },
  computed: {
    routerlist(){
      return [{to:'/',name:'Home'},{name:'Projects'}];
    }
  },
};
</script>

<style lang="less" scoped>
.project-wrapper {
  padding-top: 25px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
}
.page {
  padding: 20px 0;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>